/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
// import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SectionUI from '@components/UI/Common/SectionUI';
import BenefitsSection from '@landing_pages/GoY/sections/BenefitsSection';
import ImportantInformation from '@landing_pages/GoY/sections/ImportantInformation';
import NeedSupport from '@landing_pages/GoY/sections/NeedSupport';
import OnlineProgramDetails from '@landing_pages/GoY/sections/OnlineProgramDetails';
import ProgramDetails from '@landing_pages/GoY/sections/ProgramDetails';
import ProgramHighlights from '@landing_pages/GoY/sections/ProgramHighlights';
import StillHave from '@landing_pages/GoY/sections/StillHave';
import WhoCanAttend from '@landing_pages/GoY/sections/WhoCanAttend';
import Testimonial from '@landing_pages/GoY/Testimonial';
import TestimonialSlider from '@landing_pages/GoY/TestimonialSlider';

/**
 * Renders Render Simple Button Component
 *
 * @param {object} sectionContent - Data
 * @param sectionContent.section
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.pType
 * @param sectionContent.isLeftMenu
 * @param sectionContent.pageName
 * @param sectionContent.csrData
 * @returns {ReactElement} Render Simple Button Component
 */
const RenderSections = ({
  section,
  region,
  lang,
  pType,
  isLeftMenu,
  pageName,
  csrData,
}) => {
  if (section.sectionId === 'testimonals-section') {
    // const isMobile = useMediaQuery({ maxWidth: 478 });
    // const isMobile = useMediaQuery('(max-width: 478px)')[0];
    // consoleLog('useMediaQuery isMobile', isMobile);
    return (
      <>
        <Box display={{ base: 'block', md: 'none' }}>
          <TestimonialSlider
            testimonials={section.sectionContent[0]?.testimonials}
            lang={lang}
          />
        </Box>

        <Box display={{ base: 'none', md: 'block' }}>
          <Testimonial sectionContent={section.sectionContent[0]} />
        </Box>
      </>
    );
  } else if (section.sectionId === 'benefits-section') {
    // consoleLog('program-hightlight-section');
    return <BenefitsSection section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'program-hightlight-section') {
    // consoleLog('program-hightlight-section');
    return <ProgramHighlights section={section} />;
  } else if (section.sectionId === 'important-information-section') {
    // consoleLog('program-hightlight-section');
    return <ImportantInformation section={section} />;
  } else if (section.sectionId === 'who-attend-section') {
    // consoleLog('who-attend-section');
    return <WhoCanAttend section={section} />;
  } else if (section.sectionId === 'program-details-section') {
    // consoleLog('program-details-section');
    return (
      <ProgramDetails
        section={section}
        region={region}
        lang={lang}
        csrData={csrData}
      />
    );
  } else if (section.sectionId === 'online-porgram-schedule-section') {
    // consoleLog('online-porgram-schedule-section');
    return (
      <OnlineProgramDetails section={section} region={region} lang={lang} />
    );
  } else if (section.sectionId === 'still-have-section') {
    // consoleLog('still-have-section', section.sectionContent);
    return <StillHave section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'need-support-section') {
    return (
      <NeedSupport
        section={section}
        region={region}
        lang={lang}
        csrData={csrData}
      />
    );
  } else {
    // return <></>;
    return (
      <Box className={section.sectionId} as="div" display="block" placeContent="center">
        {section?.sectionContent && section?.sectionContent?.length
          ? section?.sectionContent?.map((secCon, i) => {
              return (
                <SectionUI
                  key={i}
                  sectionContent={secCon}
                  section={section}
                  region={region}
                  language={lang}
                  isLeftMenu={isLeftMenu}
                  pType={pType}
                  pageName={pageName}
                  csrData={csrData}
                />
              );
            })
          : null}
      </Box>
    );
  }
};

export default RenderSections;
